import { NewPagePref } from './new-page-prefs';
import { ListWithinList } from './list-within-list';

export class NewPageList {
  type: string;
  text: string;
  url: string;
  urlAlias: string;
  listItems = new Array<string>();
  contentMandatoryList = new Array<string>();
  aboutPrefs = new NewPagePref();
  listWithinListList = new Array<ListWithinList>();

  hasPrefs: boolean = false;

  /** Added By @ashutoshpw */
  sessionId: string;

  // Suggested by Pranav
  // hasSelectedSpeakers ?: boolean;
  // selectedSpeakers?: string[]


  hasSpecificSpeakers ?: boolean;
  specificSpeakersList?: string[]

  hasSpecificTopics ?: boolean;
  specificTopicsList ?: string[]

}



// WEBPACK FOOTER //
// /app/src/app/core/models/new-page-list.ts